import module from 'fan/proyecto/module.js'
import template from './template.html'

export class FanProyectoEsquemasEsquemaImpuestosAgregarComponent {
  data
  onClose
  impuestos = []
  impuesto = undefined
  porcentaje = null

  constructor (FanProyectoEsquemasImpuestos) {
    this.FanProyectoEsquemasImpuestos = FanProyectoEsquemasImpuestos
  }

  $onChanges () {
    this.FanProyectoEsquemasImpuestos.get()
      .then(({data}) => {
        this.impuestos = data.filter((a) => !this.data.find(b => a.id === b.impuestoId && a.tipoId === b.tipoId))
      })
  }

  agregar () {
    if (!this.impuesto || !this.porcentaje) return

    const detail = {
      impuestoId: this.impuesto.id,
      descripcion: this.impuesto.descripcion,
      tipoId: this.impuesto.tipoId,
      tipoFactorId: this.impuesto.tipoFactorId,
      porcentaje: this.porcentaje,
    }

    this.onClose({$event: {detail}})
  }

  cerrar () {
    this.onClose()
  }
}

module.component('fanProyectoEsquemasEsquemaImpuestosAgregar', {
  controller: FanProyectoEsquemasEsquemaImpuestosAgregarComponent,
  template,
  bindings: {
    data: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/esquemas/esquema/impuestos/agregar/component.js